export const CUSTOM_SUGGESTIONS_LIST = [
  'Jordan',
  'Supreme',
  'Bearbrick',
  'Eric Emanuel EE Basic Short',
  'Nike Air VaporMax 2021',
  'On Running Cloud',
  'Bad Bunny',
  'Blue Dunks',
  'Goyard Bag',
  'RTX',
].reverse();
